import { useState } from "react";
import {
  useGetStoreList,
  useGetSuppliers,
} from "../../../../hooks/api/queries";
import { useUrlSearch } from "../../../../hooks/useUrlSearch";

const useSuppliers = () => {
  const { queries, search, gotoPage, filterBySearch, filterByKey } =
    useUrlSearch();

  const [isCreateSupplier, setIsCreateSupplier] = useState(false);

  const { data: storeList } = useGetStoreList({});

  const {
    isLoading: isFetchingSuppliers,
    data: suppliers,
    refetch: handleFetchSuppliers,
  } = useGetSuppliers(queries, true);

  const rawStoreId = search.get("store_id");
  const selectedStoreIds = rawStoreId
    ? decodeURIComponent(rawStoreId).split("|")
    : [];

  const filterByStores = (storeIds) => {
    filterByKey("store_id", storeIds?.join("|") || null);
  };

  return {
    isFetchingSuppliers,
    metaDetails: suppliers?.meta || {},
    isCreateSupplier,
    suppliers: suppliers?.data || [],
    search,
    storeList: storeList || [],
    selectedStoreIds,
    setIsCreateSupplier,
    handleFetchSuppliers,
    gotoPage,
    filterBySearch,
    filterByStores,
  };
};
export default useSuppliers;
